import { render, staticRenderFns } from "./addGoodsSku.vue?vue&type=template&id=03d5d764&scoped=true"
import script from "./addGoodsSku.vue?vue&type=script&lang=js"
export * from "./addGoodsSku.vue?vue&type=script&lang=js"
import style0 from "./addGoodsSku.vue?vue&type=style&index=0&id=03d5d764&lang=scss"
import style1 from "./addGoodsSku.vue?vue&type=style&index=1&id=03d5d764&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d5d764",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03d5d764')) {
      api.createRecord('03d5d764', component.options)
    } else {
      api.reload('03d5d764', component.options)
    }
    module.hot.accept("./addGoodsSku.vue?vue&type=template&id=03d5d764&scoped=true", function () {
      api.rerender('03d5d764', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/salesControl/publish/addGoodsSku.vue"
export default component.exports